var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{attrs:{"config":_vm.config,"disabled":_vm.disabled,"read-only":_vm.disabled},on:{"blur":function($event){return _vm.onEditorChange(_vm.content)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }